export default (value) => {
  if (!value.length) return true;
  return /^[+]?[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(value);
};
